import React from 'react';
import mainBG from '../../../assets/EinführungMainBG.png';
import ellipseBG from '../../../assets/EllipseBG.png';
import { useTranslation } from "react-i18next";
import { getStreamUrl } from "../../../utils/videoUrl";

const PresentationStart = ({ nextClick, backClick }) => {
    const isSmallScreen = window.innerHeight <= 600;
    const { t } = useTranslation();

    return (
        <div style={{ background: `url(${mainBG})` }} className="h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between">
            {/* Title */}
            <div className="font-bold text-lg text-[#0F32C0E5] italic self-center py-6 sm:py-8">
                {t(`s-13-title`)}
            </div>

            {/* Content Section */}
            <div style={{ background: `url(${ellipseBG})` }} className="min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative">
                <div className={`relative ${isSmallScreen ? 'pt-12' : 'pt-20'} mx-auto w-full max-w-[36rem] flex flex-col justify-between h-full text-center pb-4 px-6 sm:px-0`}>
                    
                    {/* Heading */}
                    <h1 className="font-semibold text-white text-lg mt-4">{t(`s-13-heading`)}</h1>

                    {/* Video */}
                    <div className="mt-6">
                        <video className="w-full max-w-[320px] sm:max-w-[400px] mx-auto rounded-lg shadow-lg" controls>
                            <source src={getStreamUrl(t(`video_link_1`))} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    {/* Description */}
                    <h1 className="font-semibold text-white text-sm mt-6">{t(`s-13-desc`)}</h1>

                    {/* Buttons */}
                    <div className={`w-full max-w-[32rem] flex gap-6 flex-col-reverse sm:flex-row ${isSmallScreen ? 'pt-2' : 'pt-6'}`}>
                        <button className="w-full button_primary" onClick={backClick}>
                            {t(`s-2-btn1`)}
                        </button>
                        <button className="w-full button_secodry" onClick={nextClick}>
                            {t(`s-2-btn2`)}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PresentationStart;
